<template>
  <div class="the_headert w-full h-full">
    <div class="container p-8">
      <div class="sm:flex mb-4">
        <div class="sm:w-2/5 h-auto sm:mt-0 mt-8">
          <div class="text-orange text-base font-bold mb-6">
            <svg-icon
              name="logo"
              class="h-8 cursor-pointer"
              original
              color="white"
            />
          </div>
          <div class="list-reset leading-normal">
            <div
              class="desc"
              @click="goTo('recommandation')"
            >
              Nous fournissons des solutions numériques aux startups et donnons vie à vos idées.
              <br>
              N’hésitez pas à nous contacter ☺️
            </div>
          </div>
        </div>

        <div class="md:w-3/5 md:flex justify-end md:mt-0  mt-16">
          <div class="sm:w-1/3 h-auto sm:mt-0 mt-8 mr-10">
            <div class="text-orange text-base font-bold ">
              Contact
            </div>
            <div class="list-reset leading-normal">
              <div
                class="text-grey-darker"
              >
                contact@41devs.com
              </div>
              <div
                class="text-grey-darker"
              >
                (00229) 967 - 304 - 96
              </div>
              <div
                class="text-grey-darker"
              >
                (00229) 948 - 763 - 63
              </div>
            </div>
          </div>

          <div class="sm:w-1/4 h-auto sm:mt-0 md:mt-8 mt-12">
            <div
              class="text-grey-darker cursor-pointer"
              @click="goTo('accueil')"
            >
              Accueil
            </div>
            <div class="list-reset leading-normal">
              <div
                class="text-grey-darker"
                @click="goScroll('solution')"
              >
                Solutions
              </div>
              <div
                class="text-grey-darker"
                @click="goTo('portfolio')"
              >
                Portfolio
              </div>
              <div
                class="text-grey-darker"
                @click="goTo('carriere')"
              >
                Carrière
              </div>
            </div>
          </div>

          <div class="sm:w-1/4 sm:mt-0 md:mt-8 mt-12 h-auto">
            <div class="list-reset leading-normal">
              <div
                class="text-grey-darker"
                @click="goPage('https://web.facebook.com/41Devs')"
              >
                Facebook
              </div>
              <div
                class="text-grey-darker"
                @click="goPage('https://www.linkedin.com/company/41devs/mycompany/')"
              >
                Linkedin
              </div>
              <div
                class="text-grey-darker"
                @click="goPage('https://www.instagram.com/41devs_company/')"
              >
                Instagram
              </div>

              <div
                class="text-grey-darker"
                @click="goPage('https://web.facebook.com/41Devs')"
              >
                Dribbble
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="foot mt-16">
      <div class="text-base">
        © 41DEVS {{year}}. Tous droits réservés
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Index',
  components: {
  },
  props: {
  },
  data () {
    return {
      mail: '',
      year: new Date().getFullYear()
    }
  },
  computed: {

  },
  methods: {
    save () {
      this.mail = ''
    },

    goTo (i) {
      this.$router.push('/' + i)
    },

    goPage (index) {
      window.open(index, '_blank')
    },

    goScroll (i) {
      if (window.location.pathname === '/accueil') {
        var myRandom = Math.floor(Math.random() * 1000)
        this.$emit('scroll', i + myRandom)
      } else {
        this.$router.push({ path: '/accueil', query: { solution: 1 } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    @import "../assets/style/sass/variables";

    .the_headert {
        padding: 50px 0px 0px 0px;
        width: 100%;
        height: auto;
        background-color: $devs_color;
      color: $white;
    }
    .container{
      padding: 40px 100px 100px 100px;
    }
    .text-orange{
        color: white;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 160%;
    }
    .list-reset{
        cursor: pointer;
    }
    div{
      color: white;
    }
    .text-grey-darker{
      margin-top: 10px;
      font-weight: normal;
      font-size: 20px;
      line-height: 160%;
    }
    .desc{
      font-weight: normal;
      font-size: 24px;
      line-height: 160%;
    }
    span{
      color: $grey1;
    }
    .foot{
      padding: 40px 0px 40px 150px;
      font-size: 18px;
      line-height: 22px;
      background-color: #361075;
    }
    @media screen and (max-width: 600px){
        .the_headert {
            padding: 0px 0px 0px 0px;
            font-size: 0.8em;
        }
      .container{
        padding: 40px 30px 0px 30px;
      }
      .desc{
        font-size: 20px;
      }
      .foot{
        padding: 40px 0px 40px 0px;
       text-align: center;
        font-size: 14px;
      }
    }
    @media screen and (min-width: 701px) and (max-width: 1024px){
      .the_headert {
        padding: 30px 0px 0px 0px;
      }
      .container{
        padding: 40px 30px 0px 30px;
      }
      .desc, .text-grey-darker{
        font-size: 20px;
      }
      .text-grey-darker{
        font-size: 18px;
      }
      .foot{
        font-size: 15px;
      }
    }
</style>
